var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 2.75C8.90588 2.75 2.75 8.90588 2.75 16.5C2.75 23.3929 7.82788 29.0854 14.4444 30.0795V20.1438H11.0426V16.5289H14.4444V14.124C14.4444 10.142 16.3845 8.39438 19.6941 8.39438C21.2795 8.39438 22.1169 8.51125 22.5143 8.56488V11.7191H20.2565C18.8512 11.7191 18.3604 13.0515 18.3604 14.553V16.5289H22.4785L21.9202 20.1438H18.3617V30.1084C25.0731 29.1995 30.25 23.4603 30.25 16.5C30.25 8.90588 24.0941 2.75 16.5 2.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.8d4f2d1648abef9e0be4a99964527a88.svg";
export { ForwardRef as ReactComponent };